module.exports = __webpack_public_path__ + "static/media/Gliscor_gaussian2.c57bdf74.png";